import { PaginatedResponse } from '@interfaces'

type MaybePaginatedResponse<T> = Partial<PaginatedResponse<T>> | T[] | null | undefined

const isNumber = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value)

const getContent = <T>(response: MaybePaginatedResponse<T>): T[] => {
	if (Array.isArray(response)) return response
	return Array.isArray(response?.content) ? response.content : []
}

export const normalizePaginatedResponse = <T>(response: MaybePaginatedResponse<T>): PaginatedResponse<T> => {
	const content = getContent(response)

	if (Array.isArray(response)) {
		return {
			content,
			number: 1,
			numberOfElements: content.length,
			totalPages: content.length > 0 ? 1 : 0,
			totalElements: content.length
		}
	}

	return {
		content,
		number: isNumber(response?.number) ? response.number : 1,
		numberOfElements: isNumber(response?.numberOfElements) ? response.numberOfElements : content.length,
		totalPages: isNumber(response?.totalPages) ? response.totalPages : content.length > 0 ? 1 : 0,
		totalElements: isNumber(response?.totalElements) ? response.totalElements : content.length
	}
}
